/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable no-param-reassign */
import BaseModel from './base-model';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import merge from 'lodash/merge';
import * as Mobx from 'mobx';
import i18n from '@i18next/i18n';
//  lodash部分引入
import has from 'lodash/has';
import set from 'lodash/set';
import get from 'lodash/get';
import isNil from 'lodash/isNil';

import TextAdjustManager from '@src/slide/domain/ui-model/element-modeles/property/text/text-adjust';
import isElementsCanGroup
    from '@src/slide/domain/ui-model/element-modeles/property/group-operation/group-condition/index';
import {
    ISlideBaseModel,
    ISlideModel,
    MoveType, SlideModelSdkTypeV3, TBindAnimationParams,
} from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import ShapeModel from '@src/slide/domain/ui-model/element-modeles/shape-model';
import {
    IElementBaseModel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import {
    ISlideModelProps,
} from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/slide-model-props.interface';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import {
    groupChildrenSortedByRootGroup,
} from '@src/slide/domain/ui-model/element-modeles/property/group-operation/enumerate';
import { createElementModel } from '../factories/element-model-factory';
import { IGroupModel } from '../Interface/group-model.interface';
import {
    IPresentationDataModel, IGroupShapeDataModel, ISlideDataModel, ITableData, ITableDataModel,
    DeltaOf, DataType, IHeightInfo, IWidthInfo, ISlideData, ILayoutDataModel, IMasterDataModel,
    IShapeDataModel,
    AnimType,
    IAnimModifyParam,
    K_DEFAULT_TRIGGER_ID,
    DrawingShapeDataModel, IDrawingShapeDataModel,
    BaseShapeDataModel,
    ColorKey,
} from '@tencent/slide-sdk-model';
import { IAnimListItem, IAnimModel } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';
import { getPathsFromObject } from '@src/slide/infrastructure/module/independent/object/object-path';
import { getAspectRatioFromSrc, getMaxSizeInContainer, isValidAspectRatio } from '../property/attachment/utils/size';
import { isAttachmentImageElement, isVideoElement } from '../../elements/element-judge';
import { MOVE_OPERATION_TYPE_MAP } from '@src/slide/domain/ui-model/converter/node-property/sdk-ui-enum-map/move-operation-type';
import { ShapePropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/shape-property-converter';
import { transaction } from '@src/slide/domain/slide-app';
import { AnimListItem } from '@src/slide/domain/ui-model/adapter/anim-handler';
import { CommentType, STPlaceholderType, STTLTimeNodeType } from '@tencent/slide-sdk-pb-model/src/ultrabuf/ultrabuf.types';
import { IObservableArray, observable } from 'mobx';
import lowerFirst from 'lodash/lowerFirst';
import {
    TimingPropertyConverter,
} from '@src/slide/domain/ui-model/converter/node-property/page/timing-property-converter';
import { ICTTLPoint } from '@tencent/slide-sdk-pb-model';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { getSrcRectByLong } from '../property/image-operation/crop-utils';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { PropertyModificationType, linkageDecoratorFactoryForSlideModel } from '../../linkage-change-helper';
import { BODY, DATE, FOOTER, NUMBER, TITLE } from '@src/slide/domain/ui-model/constant/place-holder';
import { AnimTypes } from '@tencent/slide-sdk-constants';
import { ShapeType } from '@src/slide/infrastructure/module/dependent/shape-info/graphic-type';
import { getInitialColor } from '../property/color/utils';

class SlideBaseModel extends BaseModel implements ISlideBaseModel {
    static didConvertDataSdkToUi(sdkData, uiData, rawSdk, optionObject) {
        super.didConvertDataSdkToUi(sdkData, uiData, rawSdk);
    }

    declare public sdkData: ISlideDataModel | ILayoutDataModel | IMasterDataModel | null;
    declare public props: ISlideModelProps;
    public animList: IObservableArray<IAnimListItem> = observable([]);

    private modifiedElements: IElementBaseModel[] = [];

    public constructor() {
        super();
        this.type = UIModelType.SLIDE;
    }

    public async bindSDK(sdkData): Promise<void> {
        if (this.asyncConvertChildren && this.presentationRef) {
            this.asyncConvertChildren = this.presentationRef.asyncConvertSlideChildren;
        }
        const promise = super.bindSDK(sdkData);
        if (this.parent?.asyncConvertChildren) {
            await promise;
        }
        this.bindRelationObserver?.(sdkData);
    }

    public unbindSDK() {
        this.unBindRelationObserver(this.sdkData);
        super.unbindSDK();
    }

    /**
     * 将 slide 的更新函数绑定到对应的 layout/master 上
     * @param sdkData
     * @returns
     */
    bindRelationObserver(sdkData) {
        if (this.type === UIModelType.LAYOUT) {
            const masterSdk = sdkData.getMaster?.();
            if (masterSdk) {
                this.addObserverTarget(masterSdk);
            }
        }
        if (this.type === UIModelType.SLIDE) {
            const masterSdk = sdkData.getMaster?.();
            const layoutSdk = sdkData.getLayout?.();
            if (masterSdk) {
                this.addObserverTarget(masterSdk);
            }
            if (layoutSdk) {
                this.addObserverTarget(layoutSdk);
            }
        }
    }

    /**
     * 将 slide 的更新函数解绑到对应的 layout/master 上
     * @param sdkData
     * @returns
     */
    unBindRelationObserver(sdkData) {
        if (!sdkData) {
            return;
        }
        if (this.type === UIModelType.LAYOUT) {
            const masterSdk = sdkData.getMaster?.();
            if (masterSdk) {
                this.removeObserverTarget(masterSdk);
            }
        }
        if (this.type === UIModelType.SLIDE) {
            const masterSdk = sdkData.getMaster?.();
            const layoutSdk = sdkData.getLayout?.();
            if (masterSdk) {
                this.removeObserverTarget(masterSdk);
            }
            if (layoutSdk) {
                this.removeObserverTarget(layoutSdk);
            }
        }
    }

    public get hasBackground(): boolean {
        const sdkData = this.sdkData as SlideModelSdkTypeV3;
        const ownData = sdkData?.getOwnedData() as ISlideData;
        if (!ownData?.cSld.bg?.bgPr) return false;
        const bg = ownData?.cSld.bg?.bgPr;
        if (bg?.solidFill?.egColorChoice?.srgbClr?.val) return true;
        if (bg?.gradFill) return true;
        if (bg?.blipFill) return true;
        if (bg?.pattFill) return true;
        return false;
    }


    /**
     * 添加一个Element节点到末尾
     * @param aElementTypes   添加element 的类型 可以是单个对象 or 数组
     * @param aExtraProps  添加 element 附带的属性 可以是单个对象 or 数组
     * @param aExtraInfo  包含 textBodyStyle、paragraphList 等属性信息
     */
    public addElement(aElementTypes, aExtraProps, aExtraInfo = null): void {
        window.log.info('slide addElement');
        if (!this.sdkData) return;

        const { elementTypes, extraProps, extraInfo } = this.getElementInfo(aElementTypes, aExtraProps, aExtraInfo);

        const sdkDataArr: Array<any> = [];
        for (let i = 0; i < elementTypes.length; i++) {
            const curElementType = elementTypes[i];
            const curExtraProps = extraProps[i];
            const curExtraInfo = extraInfo[i];
            let sdkData = {};

            if (curElementType === UIModelType.TABLE || curElementType === UIModelType.CHART) {
                sdkData = curExtraProps;
            } else {
                const uiModel = createElementModel(curElementType);
                if (!uiModel) return;
                uiModel.props = merge(uiModel.props, curExtraProps);
                curExtraInfo && Object.keys(curExtraInfo).forEach((key) => {
                    uiModel[key] = curExtraInfo[key];
                });

                if (uiModel instanceof ShapeModel) {
                    // 因为3.0上层不再关注styleList，所以下面updateElementProps就无法从styleList中获取继承样式
                    // 从而无法获取继承的行高等属性，但是可以通过生成props的方式直接把继承属性加到uiData上
                    // 下面在更新文本框高度时要计算文本高度，所以用继承后的完整数据
                    ShapePropertyConverter.appendUiDataInheritProp(uiModel, this as unknown as ISlideModel);
                    TextAdjustManager.getInstance().updateElementProps(uiModel, uiModel.props, {
                        textBodyStyle: uiModel.textBodyStyle,
                        slideModel: this as unknown as ISlideModel,
                    });
                }
                Object.getPrototypeOf(uiModel).constructor.convertDataUiToSdk(uiModel, sdkData, this);
            }

            sdkDataArr.push(sdkData);
        }

        (this.sdkData as SlideModelSdkTypeV3)?.api.addShapes(sdkDataArr);

        Mobx.transaction(() => {
            if (!this.selectionService) return;
            // 当前选中页不是当前 slide 的话，不要进行元素选中操作
            if (this.selectionService.currentSlide !== (this as unknown as ISlideModel)) {
                return;
            }
            this.selectionService.selectedElements.clear();
            const newSlideModels = this.children.slice(-sdkDataArr.length);
            this.selectionService.selectedElements.add(...newSlideModels);
        });
    }

    public addElementWithNoSelect(aElementTypes, aExtraProps, aExtraInfo = null): void {
        if (!this.sdkData) return;

        const { elementTypes, extraProps, extraInfo } = this.getElementInfo(aElementTypes, aExtraProps, aExtraInfo);

        const sdkDataArr: Array<any> = [];
        for (let i = 0; i < elementTypes.length; i++) {
            const curElementType = elementTypes[i];
            const curExtraProps = extraProps[i];
            const curExtraInfo = extraInfo[i];
            let sdkData = {};

            if (curElementType === UIModelType.TABLE || curElementType === UIModelType.CHART) {
                sdkData = curExtraProps;
            } else {
                const uiModel = createElementModel(curElementType);
                if (!uiModel) return;
                uiModel.props = merge(uiModel.props, curExtraProps);
                curExtraInfo && Object.keys(curExtraInfo).forEach((key) => {
                    uiModel[key] = curExtraInfo[key];
                });

                if (uiModel instanceof ShapeModel) {
                    // 因为3.0上层不再关注styleList，所以下面updateElementProps就无法从styleList中获取继承样式
                    // 从而无法获取继承的行高等属性，但是可以通过生成props的方式直接把继承属性加到uiData上
                    // 下面在更新文本框高度时要计算文本高度，所以用继承后的完整数据
                    ShapePropertyConverter.appendUiDataInheritProp(uiModel, this as unknown as ISlideModel);
                    TextAdjustManager.getInstance().updateElementProps(uiModel, uiModel.props, {
                        textBodyStyle: uiModel.textBodyStyle,
                        slideModel: this as unknown as ISlideModel,
                    });
                }
                Object.getPrototypeOf(uiModel).constructor.convertDataUiToSdk(uiModel, sdkData, this);
            }

            sdkDataArr.push(sdkData);
        }

        (this.sdkData as SlideModelSdkTypeV3)?.api.addShapes(sdkDataArr);
    }

    /**
     * 添加iframe元素
     * @param extraProps
     * @param paragraphList
     */
    public addElementWithParagraphList(extraProps, paragraphList): void {
        if (!this.sdkData) return;
        const sdkData = {};
        const uiModel = new ShapeModel();
        uiModel.props.style.bgShape = ShapeType.rect;
        uiModel.props = merge(uiModel.props, extraProps);
        uiModel.paragraphList = paragraphList;
        Object.getPrototypeOf(uiModel).constructor.convertDataUiToSdk(uiModel, sdkData, this);

        // @ts-ignore
        (this.sdkData as SlideModelSdkTypeV3)?.api.addShapes([sdkData]);
        this.selectionService?.selectedElements.add(...this.children.slice(-1));

        if (!this.selectionService) return;
        this.selectionService.lastMouseDownRegion = RegionType.EDITOR;
    }

    /**
     * 调整fromIndex指定节点的层级到toIndex
     * @param {*} toIndex 调整到的位置 +1, -1, 0(置底), 2(置顶)
     * mergeMove 是否合并移动。
     * 默认选中的元素根据自身相对位置调整，开启后选中元素会调整到同一指定位置
     * @param elements
     * @param mergeMove
     */
    // eslint-disable-next-line complexity
    public moveElement(
        toIndex: number,
        elements: Array<any> = this.selectionService?.selectedElements.selectedArray || [],
        mergeMove = false,
    ): void {
        window.log.info('slide moveElement');
        if (!this.sdkData) return;
        const groupChildrenElements: Array<IElementBaseModel> = [];
        const slideElements: Array<IElementBaseModel> = [];
        for (let i = 0; elements && i < elements.length; i++) {
            const element = elements[i];
            if (element.parent && element.parent.type === UIModelType.GROUP) {
                groupChildrenElements.push(element);
            } else {
                slideElements.push(element);
            }
        }
        if (slideElements.length > 0) {
            const sortSlideElements = slideElements.sort((a, b) => this.children.indexOf(a) - this.children.indexOf(b));
            const slideMoveElements = (sortSlideElements
                .map(curElement => curElement.sdkData).filter(cur => cur !== null));
            mergeMove
                ? this.moveShapesToIndex(slideMoveElements, toIndex)
                : this.moveShapes(slideMoveElements, toIndex);
        }
        if (groupChildrenElements.length > 0) {
            const groups: Array<any> = [];
            const groupItems: Array<any> = [];
            for (let i = 0; i < groupChildrenElements.length; i++) {
                const groupChild = groupChildrenElements[i];
                const currentGroup = groupChildrenElements[i].parent;
                let isFind = false;
                for (let j = 0; j < groups.length; j++) {
                    if (currentGroup?.key === groups[j]?.key) {
                        groupItems[j].push(groupChild);
                        isFind = true;
                        break;
                    }
                }
                if (!isFind) {
                    const currentLength = groups.length;
                    groups[currentLength] = currentGroup;
                    groupItems[currentLength] = [groupChild];
                }
            }
            transaction(() => {
                for (let i = 0; i < groups.length; i++) {
                    const groupItem = groups[i];
                    const sortGroupElements = this.selectionService?.selectedSlides
                        .sortSelectedArray(groupItem, groupItems[i]);
                    const groupMoveSdkElements = sortGroupElements?.map(curElement => curElement.sdkData);
                    const sdkData = groupItem.sdkData as unknown as IGroupShapeDataModel;
                    mergeMove
                        ? sdkData.api.moveShapes(groupMoveSdkElements as IDrawingShapeDataModel[], toIndex)
                        : sdkData.api.reorderShapes(
                            groupMoveSdkElements as IDrawingShapeDataModel[],
                            MOVE_OPERATION_TYPE_MAP.get(Number(toIndex))!,
                        );
                }
            });
        }
    }

    public setCurrentElementToFrontOrBack(
        moveType,
        elements: Array<any> = this.selectionService?.selectedElements.selectedArray || [],
    ): void {
        window.log.info('slide setCurrentElementToFrontOrBack');

        let toIndex = 0;
        switch (moveType) {
            case MoveType.FRONT:
                toIndex = 2;
                break;
            case MoveType.BACK:
                toIndex = 0;
                break;
            default:
                break;
        }
        this.moveElement(toIndex, elements);
    }

    /**
     * 删除指定的Element对象或者指定位置的shape节点
     * @param elements
     */
    deleteElement(elements: Array<any> = this.selectionService?.selectedElements.selectedArray || []) {
        window.log.info('slide deleteElement');
        if (!this.sdkData) return;
        if (elements && elements.length > 0) {
            const phElements: Array<any> = [];
            const groupChildrenElements: Array<any> = [];

            if (this.getMasterLayoutEditService()?.isMasterEditType) {
                this.deleteElementsAndAddPlaceHolderInMaster(elements);
                return;
            }

            // 根据shape来源是否为从placeholder创建分离成两个数组
            const deleteElements = elements.filter((curElement) => {
                if (curElement.isCustomPlaceholder) {
                    phElements.push(curElement);
                    return false;
                }
                if (curElement.parent.type === UIModelType.GROUP) {
                    groupChildrenElements.push(curElement);
                    return false;
                }
                return true;
            }).map(curElement => curElement.sdkData);


            if (phElements.length > 0) {
                // 删除由placeholder创建的shape时合并changeside
                this.deleteElementsAndAddPlaceHolder(phElements, deleteElements);
            } else {
                // 删除非placeholder创建的shape时直接删掉
                if (deleteElements.length > 0) {
                    this.deleteShapes(deleteElements);
                    // 存在删除这个之前就已经删除掉的case，全部清除掉会不对，改deleteShapes为remove；//http://tapd.oa.com/TIM_web/bugtrace/bugs/view?bug_id=1010143861073277205&from=wxnotification
                    this.selectionService?.selectedElements.remove(...elements);
                }
                if (groupChildrenElements.length > 0) {
                    groupChildrenSortedByRootGroup(groupChildrenElements, (rootGroups, groupChildrenMatrix) => {
                        transaction(() => {
                            if (rootGroups
                                && rootGroups.length > 0
                                && groupChildrenMatrix
                                && groupChildrenMatrix.length > 0
                                && rootGroups.length === groupChildrenMatrix.length
                            ) {
                                for (let i = 0; i < rootGroups.length; i++) {
                                    rootGroups[i].sdkData.api.deleteShapes(groupChildrenMatrix[i]
                                        .map(groupElement => groupElement.sdkData));
                                }
                            }
                        });
                    });
                }
            }
        }
    }

    /**
     * smartart元素转化成组合
     * @param elements 要合并成组的uiModel.
     */
    convertToGroup(elements: Array<any> = this.selectionService?.selectedElements.selectedArray || []) {
        window.log.info('slide convertToGroup');
        if (!this.sdkData) return;
        const newSlideModels: Array<any> = [];

        if (elements && elements.length > 0) {
            const sdkSmartArtElements = elements.map(curElement => curElement.sdkData);
            transaction(() => {
                sdkSmartArtElements.forEach((smartartElement) => {
                    this.convertSmartArtToGroup(smartartElement);
                });
            });
        }
    }
    /**
     * 将元素成组，如果多选元素有任一元素不能成组，则都不能成组
     * @param elements 要合并成组的uiModel array.
     */
    groupElements(elements: Array<any> = this.selectionService?.selectedElements.selectedArray || []) {
        window.log.info('slide groupElement');
        if (!this.sdkData) return;
        if (!isElementsCanGroup(elements)) return;
        if (elements && elements.length > 0) {
            let lastElement: IElementBaseModel | null = null;
            let lastIndex = -1;
            const matchedElements = elements.map((curElement) => {
                const currentIndex = curElement.soruceRefForUI.children.indexOf(curElement);
                if (currentIndex + 1 < curElement.soruceRefForUI.children.length) {
                    if (lastIndex < currentIndex + 1) {
                        lastIndex = currentIndex + 1;
                        lastElement = curElement.soruceRefForUI.children[currentIndex + 1];
                    }
                } else {
                    lastIndex = curElement.soruceRefForUI.children.length;
                    lastElement = null;
                }
                return curElement.sdkData;
            });
            if (matchedElements && matchedElements.length > 1) {
                this.group(matchedElements);
                Mobx.transaction(() => {
                    this.selectionService?.selectedElements.clear();
                    let newSlideModels: Array<any> = [];
                    if (lastElement) {
                        const lastIndex = lastElement?.soruceRefForUI?.children.indexOf(lastElement);
                        if (lastIndex && lastIndex > 0) {
                            newSlideModels.push(lastElement?.soruceRefForUI?.children[lastIndex - 1]);
                        }
                    } else {
                        newSlideModels = this.children.slice(-1);
                    }
                    this.selectionService?.selectedElements.add(...newSlideModels);
                });
            }
        }
    }

    /**
     * 拆除选中元素里的组合元素，只拆一层
     * @param elements 要拆开的的uiModel array.
     */
    public unGroupElements(elements: Array<any> = this.selectionService?.selectedElements.selectedArray || []): void {
        window.log.info('slide unGroupElement');
        if (!this.sdkData) return;

        if (elements && elements.length > 0) {
            const groupElements = elements.filter((curElement) => {
                if (curElement.isPlaceholder) { // 占位符不能成组
                    return false;
                }
                if (curElement.type !== UIModelType.GROUP) { // 只有组合才能解组
                    return false;
                }
                if (curElement.parent.type === UIModelType.GROUP) { // 应该最外面的组合元素来进行解组
                    return false;
                }
                return true;
            });
            const sdkGroupElements = groupElements.map(curElement => curElement.sdkData);
            if (sdkGroupElements) { // todo 这个变量至少得是个空[], 所以应该判断.length > 0, 或者去掉该if
                const beforeChildrenKey: Array<any> = [];
                for (let i = 0; i < this.children.length; i++) {
                    beforeChildrenKey.push(this.children[i].key);
                }
                transaction(() => {
                    sdkGroupElements.forEach((groupElement) => {
                        this.ungroup(groupElement);
                    });
                });
                Mobx.transaction(() => {
                    this.selectionService?.selectedElements.clear();
                    for (let i = 0; i < this.children.length; i++) {
                        if (!beforeChildrenKey.includes(this.children[i].key)) {
                            this.selectionService?.selectedElements.add(this.children[i]);
                        }
                    }
                });
            }
        }
    }

    // TODO 后续需要优化 此类接口情况 （合并多个接口调用方式）
    /**
     *
     * @param delEles   类型 Array
     * @param addNewEleInfos 类型 Array
     * 元素对象: {
     *          eleType              // 添加的 UIModelType 类型
     *          eleProps             // 附带 属性
     *      }
     */
    deletePlaceHolderAndAddNewElements(delEles, addNewEleInfos) {
        const deleteArr = delEles.map(curElement => curElement.sdkData);

        const addSdkArr = addNewEleInfos.map((ele) => {
            let sdkData = {};
            // TODO 翔仔的逻辑应该单独抽一个借口
            if (ele.eleType === UIModelType.TABLE || ele.eleType === UIModelType.CHART) {
                sdkData = ele.eleProps;
            } else {
                const uiModel = createElementModel(ele.eleType);
                if (!uiModel) return sdkData;
                uiModel.props = merge(uiModel.props, ele.eleProps);
                Object.getPrototypeOf(uiModel).constructor.convertDataUiToSdk(uiModel, sdkData, this);
            }
            return sdkData;
        });

        transaction(() => {
            this.deleteShapes(deleteArr);
            (this.sdkData as SlideModelSdkTypeV3)?.api.addShapes(addSdkArr);
        });

        Mobx.transaction(() => {
            this.selectionService?.selectedElements.clear();
            const newSlideModels = this.children.slice(-addSdkArr.length);
            this.selectionService?.selectedElements.add(...newSlideModels);
        });
    }

    deleteElementsAndAddPlaceHolderInMaster(elements: IElementBaseModel[]) {
        const plShapes: IElementBaseModel[] = [];
        const normalShapes = elements.filter((curElement) => {
            if (curElement.isPlaceholder) {
                plShapes.push(curElement);
                return false;
            }
            if (curElement.parent?.type === UIModelType.GROUP) {
                return false;
            }
            return true;
        }).map(curElement => (curElement.sdkData));
        const plToLabelName = {
            [STPlaceholderType[STPlaceholderType.title]]: TITLE,
            [STPlaceholderType[STPlaceholderType.ctrTitle]]: TITLE,
            [STPlaceholderType[STPlaceholderType.body]]: BODY,
            [STPlaceholderType[STPlaceholderType.dt]]: DATE,
            [STPlaceholderType[STPlaceholderType.ftr]]: FOOTER,
            [STPlaceholderType[STPlaceholderType.sldNum]]: NUMBER,
        };
        transaction(() => {
            if (normalShapes.length) {
                this.deleteShapes(normalShapes);
            }
            plShapes.forEach((plShape) => {
                this.updatePlaceholderFormat?.({
                    value: plToLabelName[plShape.placeHolder?.type || ''],
                    targetShape: plShape,
                });
            });
        });
    }

    updatePlaceholderFormat(params) {}

    /**
     *
     * @param shapes 由placeholder创建而来的shape
     */
    deleteElementsAndAddPlaceHolder(shapes, deleteElements) {
        window.log.info('slide deleteElementsAndAddPlaceHolder');
        if (shapes.length < 1) return;

        const styles: Array<any> = [];
        shapes.forEach((curElement) => {
            const style = {
                style: {
                    placeholder: undefined,
                },
            };

            if (has(curElement, 'placeHolder.index')) {
                set(style, 'style.placeholder.index', curElement.placeHolder.index);
            }

            if (has(curElement, 'placeHolder.type')) {
                set(style, 'style.placeholder.type', curElement.placeHolder.type);
            }

            if (style.style.placeholder) {
                const shapeOnLayoutOrMaster = (curElement.sdkData as IShapeDataModel).getRelatedPlaceholder();
                if (!shapeOnLayoutOrMaster) {
                    set(style, 'style.placeholder.removed', true);
                }
            }
            set(style, 'style.placeholder.reset', true);

            styles.push(style);
        });

        const deleteArr = shapes.map(curElement => curElement.sdkData);


        const addSdkArr = styles
            .filter((ele) => {
                if (has(ele, 'style.placeholder') && has(ele, 'style.placeholder.removed')  && ele.style.placeholder.removed) {
                    return false;
                }
                return true;
            })
            .map(function (ele) {
                const sdkData = {};
                const uiModel = new ShapeModel();
                if (!uiModel) return sdkData;
                uiModel.props = merge(uiModel.props, ele);
                this.updateUiModelBeforeConvert(uiModel);
                Object.getPrototypeOf(uiModel).constructor.convertDataUiToSdk(uiModel, sdkData, this);
                return sdkData;
            }, this);

        transaction(() => {
            this.deleteShapes(deleteElements);
            this.deleteShapes(deleteArr);
            if (addSdkArr.length > 0) {
                // @ts-ignore
                (this.sdkData as SlideModelSdkTypeV3)?.api.addShapes(addSdkArr);
            }
        });

        Mobx.transaction(() => {
            this.selectionService?.selectedElements.clear();
            const newSlideModels = this.children.slice(-addSdkArr.length);
            this.selectionService?.selectedElements.add(...newSlideModels);
        });
    }
    @linkageDecoratorFactoryForSlideModel(2, [['props', PropertyModificationType.update], ['props', PropertyModificationType.remove]])
    // eslint-disable-next-line complexity
    updateAndRemovePropsForElements(
        propsArr,
        removeProps,
        elements: Array<IElementBaseModel> = this.selectionService?.selectedElements.selectedArray || [],
    ) {
        window.log.info(`${'slide updateAndRemovePropsForElements '
            + '[elements.length] = '}${elements.length
        } [propsArr.length] = ${propsArr.length
        } [removeProps.length] = ${removeProps.length}`);

        if (!(Array.isArray(elements) || Mobx.isObservableArray(elements))
            || !(Array.isArray(propsArr) || Mobx.isObservableArray(propsArr))
            || !(Array.isArray(removeProps) || Mobx.isObservableArray(removeProps))
            || elements.length !== propsArr.length || elements.length !== removeProps.length) {
            return false;
        }

        const sdkDataArr: Array<any> = [];
        const sdkPropsArr: Array<any> = [];
        const rmSdkPropsArr: Array<any> = [];

        elements.forEach((itemUiModel, index) => {
            if (itemUiModel.sdkData) {
                const sdkProps = itemUiModel.prepareSDKData({ props: propsArr[index] });
                sdkPropsArr.push(sdkProps);

                const rmProp = removeProps[index];
                if (rmProp) {
                    const rmSdkProps = itemUiModel.prepareSDKData({ props: rmProp });
                    rmSdkPropsArr.push(rmSdkProps);
                } else {
                    rmSdkPropsArr.push(undefined);
                }

                sdkDataArr.push(itemUiModel.sdkData);
            }
        });

        (this.presentationRef?.sdkData as IPresentationDataModel | null)?.api
            .forEachInTransaction(sdkDataArr as IDrawingShapeDataModel[], (shape: IDrawingShapeDataModel, i) => {
                const toRemovePaths = getPathsFromObject(rmSdkPropsArr[i]);
                toRemovePaths.forEach((path) => {
                    set(sdkPropsArr[i], path, null);
                });
                BaseModel.sdkV3UpdateProps(shape, sdkPropsArr[i]);
            });
    }

    /**
     * 根据placeholder index 和 element的style 重新创建一个placeholder插入slide
     * @param elements
     */
    addPHElement(elements = this.selectionService?.selectedElements.selectedArray || []) {
        window.log.info('slide addPHElement');

        const types: Array<any> = [];
        const styles: Array<any> = [];
        elements.forEach((curElement) => {
            const style = {
                // style : curElement.props.style
            };

            if (has(curElement, 'placeHolder.index')) {
                // @ts-ignore
                set(style, 'style.placeholder.index', curElement.placeHolder.index);
            }

            if (has(curElement, 'placeHolder.type')) {
                // @ts-ignore
                set(style, 'style.placeholder.type', curElement.placeHolder.type);
            }
            set(style, 'style.placeholder.reset', true);

            types.push(UIModelType.SHAPE);
            styles.push(style);
        });
        this.addElement(types, styles);
    }

    /**
     * 更新当前Slide 下 element 数据更新的批量接口。
     * @param elements      UiModels Array
     * @param props         对应 @param elements 顺序的 props 数组
     * @returns {boolean}   是否成功
     */
    @linkageDecoratorFactoryForSlideModel(1, [['props', PropertyModificationType.update]])
    updateElementsProps(
        propsArr,
        elements: Array<any> = this.selectionService?.selectedElements.selectedArray || [],
    ) {
        window.log.info(`slide updateElementsProps [elements.length] = ${elements.length} [propsArr.length] = ${propsArr.length}`);

        if (!(Array.isArray(elements) || Mobx.isObservableArray(elements))
            || !(Array.isArray(propsArr) || Mobx.isObservableArray(propsArr))
            || elements.length !== propsArr.length) {
            return false;
        }

        const sdkDataArr: Array<any> = [];
        const sdkPropsArr: Array<any> = [];

        elements.forEach((itemUiModel, index) => {
            if (itemUiModel.sdkData) {
                const sdkProps = itemUiModel.prepareSDKData({
                    props: this.calcAttachmentSrcRect(itemUiModel, propsArr[index]),
                });
                sdkPropsArr.push(sdkProps);
                sdkDataArr.push(itemUiModel.sdkData);
            }
        });


        (this.presentationRef?.sdkData as IPresentationDataModel | null)?.api
            .forEachInTransaction(sdkDataArr as IDrawingShapeDataModel[], (shape: DrawingShapeDataModel, i) => {
                if (shape.type === DataType.GraphicalObjectFrameTable) {
                    this.resizeTableSize(shape, sdkPropsArr[i]);
                } else {
                    BaseModel.sdkV3UpdateProps(shape, sdkPropsArr[i]);
                }
            });
    }

    /**
     * 视频和图片附件尺寸变化时，重新计算 srcRect 属性，用来保证
     * 1. 导出之后图片和视频不变形
     * 2. 左侧缩略图中图片和视频不变形
     * @param itemUiModel
     * @param props
     * @returns
     */
    calcAttachmentSrcRect(itemUiModel, props) {
        if (!props.style) {
            return props;
        }
        if (!isVideoElement(itemUiModel) && !isAttachmentImageElement(itemUiModel)) {
            return props;
        }
        if (isVideoElement(itemUiModel)) {
            return props;
        }

        const { style: originStyle, src } = itemUiModel.props;
        const aspectRatio = getAspectRatioFromSrc(src);
        if (isValidAspectRatio(aspectRatio)) {
            const { width: modelWidth = originStyle.width, height: modelHeight = originStyle.height } = props.style;
            // 计算出在当前 model 宽高范围内，视频和图片附件不变形的情况下的最大尺寸
            const { width, height } = getMaxSizeInContainer(aspectRatio, modelWidth, modelHeight);
            // 计算出要想让 pictureModel 主内容渲染区域为 width height 的话，srcRect 的值
            const srcRect = getSrcRectByLong(width, height, modelWidth, modelHeight);
            return {
                ...props,
                style: {
                    ...props.style,
                    srcRect,
                },
            };
        }
        return props;
    }

    /**
     *
     * @param get all elements of placeholder type in slide
     * only for tbl and pic
     * @returns {Array}
     */
    getElementsOfPlaceholderTypeInSlideExceptSlected(type) {
        const elementArray: Array<any> = [];
        for (let i = 0; i < this.children.length; i++) {
            const element = this.children[i];
            if (element.isPlaceholder
                && !element.isCustomPlaceholder
                && (element.placeHolder.type === type || typeof (element.placeHolder.type) === 'undefined')
                && !element.selected) {
                elementArray.push(element);
            }
        }
        return elementArray;
    }

    selectAll() {
        Mobx.transaction(() => {
            this.selectionService?.selectedElements.clear();

            const elements: Array<any> = [];
            this.children.forEach((curItem) => {
                if (curItem.selectable === true) {
                    elements.push(curItem);
                }
            });

            this.selectionService?.selectedElements.add(...elements);
        });
    }


    childUiModelFromId(childId) {
        // eslint-disable-next-line no-underscore-dangle
        return this._elementOfChildren(childId, this);
    }

    _elementOfChildren(childId, uiModel) {
        let result: IBaseModel | null = null;
        for (let i = 0; uiModel?.children && i < uiModel.children.length; i++) {
            result = uiModel.children[i];
            // eslint-disable-next-line no-underscore-dangle
            if (childId === result?.id || (result = this._elementOfChildren(childId, result))) {
                break;
            }
        }
        return result;
    }

    /**
     * 添加动画接口
     * @param {*} uiModels
     * @param {*} animType
     */
    addAnimation(uiModels: Array<IElementBaseModel>, animType, subType?): boolean {
        if (!uiModels || uiModels.length === 0) {
            window.log.info('addAnimation uiModel is undefined');
            return false;
        }
        const sdkDatas: Array<any> = [];
        uiModels.forEach((uiModel) => {
            sdkDatas.push(uiModel.sdkData);
        });
        const shapeIds = uiModels.map(item => item.sdkData?.id || '') || [];
        let length = 0;
        this.animList.forEach((animListItem: AnimListItem) => {
            if (animListItem.sequenceTypes === lowerFirst(STTLTimeNodeType[STTLTimeNodeType.mainSeq])) {
                length = animListItem.data.length;
            }
        });
        const addAnimationParam = {
            shapeIds,
            subType,
            animType: animType || AnimType.FadeIn,
            triggerId: K_DEFAULT_TRIGGER_ID,
            index: length,
        };
        (this.sdkData as SlideModelSdkTypeV3)?.timing?.api.addAnimation(addAnimationParam);
        return true;
    }

    /**
     * 删除动画
     */
    removeAnimation(animModel: IAnimModel) {
        if (!animModel.sdkData) {
            console.log('removeAnimation animModel is undefined');
            return;
        }
        if (!animModel.clickSpid) return;
        const animListItem = this.animList.find(item => item.clickSpid === animModel.clickSpid);
        if (!animListItem) return;
        const index = animListItem.data.indexOf(animModel);
        if (index === -1) return;
        (this.sdkData as SlideModelSdkTypeV3)?.timing?.api
            .removeAnimation(TimingPropertyConverter.getSdkTriggerId(animModel.clickSpid), index);
    }

    /**
     * 修改动画
     * AnimModiyParam {
     *      duration: number;
     *      delay: number;
     *      nodeType: string;           ----  AnimModel[nodeTypes]
     *      animType: string;           ----  AnimModel[ANIM_TYPES]
     *      subType: number;            ----  AnimModel[subTypes]
     *      by:                         ----  AnimModel[by] scale时为{x:x, y:y}、rotate时为number
     *  }
     */
    modifyAnimation(animModel: IAnimModel, animModiyParam) {
        if (!animModel || !animModiyParam) {
            console.log('modifyAnimation animModel or animModiyParam is undefined');
            return;
        }
        const animModifyParamV3 = this.getAnimationModifyParamsV3(animModel.props.animType as AnimType, animModiyParam);
        if (!animModel.clickSpid) return;
        const animListItem = this.animList.find(item => item.clickSpid === animModel.clickSpid);
        if (!animListItem) return;
        const index = animListItem.data.indexOf(animModel);
        if (index === -1) return;
        animModifyParamV3.shapeId = animModel.spid;

        if (Object.hasOwnProperty.call(animModiyParam, 'audio') || Object.hasOwnProperty.call(animModiyParam, 'video')) {
            (this.sdkData as ISlideDataModel).timing?.api?.modifyOriginMediaAnimation(
                TimingPropertyConverter.getSdkTriggerId(animModel.clickSpid),
                animModel.spid,
                index,
                animModifyParamV3,
            );
        } else {
            (this.sdkData as ISlideDataModel).timing?.api.modifyAnimation(
                TimingPropertyConverter.getSdkTriggerId(animModel.clickSpid),
                index, animModifyParamV3,
            );
        }
    }

    /**
     * 绑定动画
     * @param params TBindAnimationParams
     * @returns boolean 是否绑定成功
     */
    bindAnimation(params: TBindAnimationParams): boolean {
        const { uiModel, animEffects, originId: originTriggerId, rebind } = params || {};
        if (!uiModel || !animEffects || !animEffects.length) {
            window.log.info('no uiModel or animation effects');
            return false;
        }
        const { sdkData } = uiModel;
        const shapeId = sdkData?.id || '';

        const animIndexMap: Map<string, number> = new Map();
        const list = [...this.animList];
        // 收集不同触发器动画队列长度，如果 rebind 为 true 则移除队列上 shapeId 原本绑定的动画
        list.forEach((animListItem: AnimListItem) => {
            const len = animIndexMap.get(animListItem.clickSpid) || 0;
            const removeCount = this.removeAnimByShapeId(animListItem, rebind ? shapeId : undefined);

            animIndexMap.set(animListItem.clickSpid, len + animListItem.data.length - removeCount);
        });

        animEffects.forEach((anim) => {
            const { animType } = anim.props || {};
            // 当复制的动画来源与当前动画触发器一致时，修改触发器 id 为当前元素的 id
            const triggerId = anim.clickSpid === originTriggerId
                ? shapeId : TimingPropertyConverter.getSdkTriggerId(anim.clickSpid);
            const indexKey = anim.clickSpid === originTriggerId ? shapeId : anim.clickSpid;
            const index = animIndexMap.get(indexKey) || 0;
            animIndexMap.set(indexKey, index + 1); // 更新不同触发器动画队列长度

            // 加入不同队列
            (this.sdkData as SlideModelSdkTypeV3)?.timing?.api
                .addAnimation({ shapeIds: [shapeId],
                    animType: animType || AnimType.FadeIn,
                    triggerId,
                    index,
                });
            // 针对颜色动画，需要提出颜色值再进行在进行修改
            const color = this.getAnimationColorProperty(anim);
            // 动画属性对齐
            const animParams = this.getAnimationModifyParamsV3(animType, {
                ...anim.props,
                color,
                clickSpid: anim.props.triggerId ? triggerId : undefined,
            });
            animParams.shapeId = shapeId;
            let { presetSubtype } = animParams;
            // 参考 animationItem 中逻辑，陀螺旋方向通过 by 设置
            if (animType === AnimTypes.SCALE || animType === AnimTypes.ROTATE) {
                presetSubtype = undefined;
            }
            (this.sdkData as ISlideDataModel).timing?.api.modifyAnimation(triggerId, index, {
                ...animParams,
                presetSubtype,
            });
        });

        return false;
    }

    /**
     * 移动动画元素
     * @param {*} fromIndex
     * @param {*} toIndex
     * @param {*} fromClickSpid
     * @param {*} toClickSpid
     */
    moveAnimation(fromIndex, toIndex, fromClickSpid, toClickSpid) {
        (this.sdkData as SlideModelSdkTypeV3)?.timing?.api
            .moveAnimation(
                fromIndex, toIndex,
                TimingPropertyConverter.getSdkTriggerId(fromClickSpid),
                TimingPropertyConverter.getSdkTriggerId(toClickSpid),
            );
    }

    updateSelectedByPatch(patch) {
        patch?.forEach((operation) => {
            if (operation.op !== 'add') return;

            // 操作 slide/master/layout 的 op path 会包含 shapeList
            const result =  /\/shapeList\/(\d+)$/.exec(operation.path);
            if (!result) return;
            const id = get(operation, 'value.id') || get(operation, 'value.valueId');
            if (!id) return;
            this.children.forEach((childModel) => {
                if (childModel.sdkData.id === id
                    && childModel.slideRef?.key === this.getSelectionService()?.currentSlide?.key) {
                    this.selectionService?.selectedElements.add(childModel);
                }
            });
        });
    }

    public get width(): number {
        if (!this.presentationRef?.props?.slideWidth) return 0;
        return this.presentationRef?.props?.slideWidth;
    }

    public get height(): number {
        if (!this.presentationRef?.props?.slideHeight) return 0;
        return this.presentationRef?.props?.slideHeight;
    }

    public willUpdateElement(ele: IElementBaseModel): void {
        if (this.modifiedElements.indexOf(ele) === -1) {
            ele && this.modifiedElements.push(ele);
        }
    }

    public updateModifiedElements() {
        const propsArr: any[] = [];
        const elements: IBaseModel[] = [];
        let hasGroupModified = false;

        if (this.modifiedElements.length > 0) {
            const [model] = this.modifiedElements;
            if (model) {
                if (model?.parent?.type === UIModelType.GROUP) {
                    const parentGroup = model.parent as IGroupModel;
                    // eslint-disable-next-line no-restricted-syntax
                    for (const ele of this.modifiedElements) {
                        this.updateOperationFrame(ele);
                    }
                    const arr = parentGroup.getFrame().getAdjustedElementsAndProps();
                    arr.forEach((item) => {
                        propsArr.push(item.props);
                        elements.push(item.uiModel);
                    });
                    if (arr.length > 0) {
                        // 当arr存在时，表明此时处理过组合，且包含了子元素
                        hasGroupModified = true;
                    }

                    // eslint-disable-next-line no-restricted-syntax
                    for (const ele of this.modifiedElements) {
                        if (ele.operationFrame) {
                            ele.operationFrame = null;
                        }
                    }
                }
            }
        }
        this.updateModifiedData(propsArr, elements, hasGroupModified);
    }

    public getStyleValue(ele, props, eleModel, attribute) {
        return props.style[attribute] || ele[attribute] || eleModel.props.style[attribute];
    }

    public updateOperationFrame(eleModel: IElementBaseModel): void {
        const props = eleModel.modifiedProps;
        if (props.style.left || props.style.top) {
            eleModel.operationFrame = {
                top: this.getStyleValue(eleModel, props, eleModel, 'top'),
                left: this.getStyleValue(eleModel, props, eleModel, 'left'),
                width: this.getStyleValue(eleModel, props, eleModel, 'width'),
                height: this.getStyleValue(eleModel, props, eleModel, 'height'),
            };
        }
    }

    public updateModifiedData(propsArr, elements, hasGroupModified: boolean) {
        const getModifiedData = (ele: IBaseModel, propsArrInner: any[], elementsInner: IBaseModel[]) => {
            if (hasGroupModified) {
                // 外层调用时已经特殊处理过组合的情况了，这里再遍历到组合模型直接跳过，避免更新时重写为脏数据
                return;
            }
            const props = (ele as any).modifiedProps;

            if (props.paragraphList || props.style) {
                elementsInner.push(ele);
                propsArrInner.push(props);
            }
            // eslint-disable-next-line no-restricted-syntax
            for (const iterator of ele.children) {
                getModifiedData(iterator, propsArrInner, elementsInner);
            }
        };

        // eslint-disable-next-line no-restricted-syntax
        for (const iterator of this.modifiedElements) {
            getModifiedData(iterator, propsArr, elements);
        }
        if (elements.length > 0) {
            this.updateElementsProps(propsArr, elements);
        }
        this.modifiedElements = [];
    }

    /**
     * 获取某个动画队列中的点击动画组
     * @param animListItem 动画队列
     * @param clickSpid 触发元素id
     * @returns
     */
    public getAnimationClickGroup(animListItem: IAnimListItem) {
        const groups: IAnimModel[][] = [];
        let curOrder: number;
        let curGroup: IAnimModel[] = [];
        animListItem.data.forEach((item) => {
            item.clickSpid = animListItem.clickSpid;
            if (item.order !== curOrder) {
                curGroup = [item];
                groups.push(curGroup);
            } else {
                curGroup.push(item);
            }
            curOrder = item.order;
        });
        return groups;
    }

    // eslint-disable-next-line complexity
    protected getAnimationModifyParamsV3(animType: AnimType, animModifyParam: any = {}) {
        const animModifyParamV3: IAnimModifyParam = {};
        const {
            duration,
            delay,
            animType: paramAnimType,
            nodeType,
            subType,
            by,
            clickSpid,
            opacity,
            color,
        } = animModifyParam;

        if (!isNil(duration)) {
            animModifyParamV3.dur = duration;
        }
        if (!isNil(delay)) {
            animModifyParamV3.delay = delay.toString();
        }
        if (!isNil(nodeType)) {
            // @ts-ignore
            animModifyParamV3.nodeType = STTLTimeNodeType[nodeType];
        }
        if (!isNil(paramAnimType)) {
            animModifyParamV3.animType = paramAnimType;
        }
        if (!isNil(subType)) {
            animModifyParamV3.presetSubtype = subType;
        }
        if (!isNil(by)) {
            if (animType === AnimType.Scale) {
                animModifyParamV3.by = by;
                (animModifyParamV3.by as ICTTLPoint).x = by.x * 100000;
                (animModifyParamV3.by as ICTTLPoint).y = by.y * 100000;
            } else if (animType === AnimType.Rotate) {
                animModifyParamV3.by = by * 60000;
            }
        }
        if (!isNil(clickSpid)) {
            animModifyParamV3.triggerId = TimingPropertyConverter.getSdkTriggerId(clickSpid);
        }
        if (!isNil(opacity)) {
            animModifyParamV3.opacity = opacity.toString();
        }

        if (!isNil(color)) {
            animModifyParamV3.color = color;
        }

        if (Object.hasOwnProperty.call(animModifyParam, 'audio')) {
            animModifyParamV3.audio = animModifyParam.audio;
        }

        // todo: 支持 video

        return animModifyParamV3;
    }

    protected getAllSDKShapesOnMaster(slideSdkData: ISlideDataModel | null) {
        if (!slideSdkData) {
            window.log?.warn(i18n.t('slide不存在'));
            return [];
        }
        const layout = slideSdkData.getLayout?.();
        if (!layout) return [];
        const master = layout.getMaster?.();
        if (master) {
            // @ts-ignore
            return [...master.shapeList.filter(shape => !shape.isPlaceholder)];
        }
        return [];
    }

    protected getAllSDKShapesOnLayout(slideSdkData: ISlideDataModel | null) {
        if (!slideSdkData) {
            window.log?.warn(i18n.t('slide不存在'));
            return [];
        }
        const layout = slideSdkData.getLayout?.();
        if (layout) {
            // @ts-ignore
            return [...layout.shapeList.filter(shape => !shape.isPlaceholder)];
        }
        return [];
    }

    protected getAllSDKShapesOnSelf(sdkData: ISlideDataModel | null) {
        if (!sdkData) {
            window.log?.warn(i18n.t('slide不存在'));
            return [];
        }
        const shapes: any[] = [];
        // @ts-ignore
        shapes.push(...sdkData.shapeList);
        return shapes;
    }

    protected deleteShapes(deleteElements): void {
        if (!this.sdkData) {
            return;
        }
        (this.sdkData as unknown as ISlideDataModel).api.deleteShapes(deleteElements);
    }

    private convertSmartArtToGroup(elements): void {
        if (!this.sdkData) {
            return;
        }
        (this.sdkData as unknown as ISlideDataModel).api.convertSmartArtToGroup(elements);
    }
    private group(elements): void {
        if (!this.sdkData) {
            return;
        }
        (this.sdkData as unknown as ISlideDataModel).api.group(elements);
    }

    private ungroup(elements): void {
        if (!this.sdkData) {
            return;
        }
        (this.sdkData as unknown as ISlideDataModel).api.ungroup(elements);
    }

    private moveShapes(elements, operation): void {
        if (!this.sdkData) {
            return;
        }
        (this.sdkData as unknown as ISlideDataModel).api
            .reorderShapes(elements, MOVE_OPERATION_TYPE_MAP.get(Number(operation))!);
    }

    private moveShapesToIndex(elements, toIndex): void {
        if (!this.sdkData) {
            return;
        }
        (this.sdkData as unknown as ISlideDataModel).api.moveShapes(elements, toIndex);
    }

    /**
     * 格式化元素信息，将其转换成统一（数组）格式
     */
    private getElementInfo(aElementTypes, aExtraProps, aExtraInfo) {
        let elementTypes: Array<any> = [];
        let extraProps: Array<any> = [];
        let extraInfo: Array<any> = [];
        if (Array.isArray(aElementTypes)) {
            if (aElementTypes.length !== aExtraProps.length) {
                window.log.info('addElement elementTypes 和 extraProps 的长度不一样！');
            } else {
                elementTypes = aElementTypes;
                extraProps = aExtraProps;
                extraInfo = aExtraInfo || [];
            }
        } else {
            elementTypes.push(aElementTypes);
            extraProps.push(aExtraProps);
            extraInfo.push(aExtraInfo);
        }
        return { elementTypes, extraProps, extraInfo };
    }

    /**
     * 恢复 placeholder 时 坐标要从母版获取，这里去掉 key
     */
    private updateUiModelBeforeConvert(uiModel) {
        if (has(uiModel, 'props.style.placeholder.reset') && uiModel.props.style.placeholder.reset) {
            if (has(uiModel, 'props.style.left')) {
                delete uiModel.props.style.left;
            }

            if (has(uiModel, 'props.style.top')) {
                delete uiModel.props.style.top;
            }

            if (has(uiModel, 'props.style.width')) {
                delete uiModel.props.style.width;
            }

            if (has(uiModel, 'props.style.height')) {
                delete uiModel.props.style.height;
            }
        }
    }

    /**
     * 3.0表格的更新涉及数组更新，格式组装比较特殊，需要单独处理
     * @param sdkData
     * @param data
     * @private
     */
    private resizeTableSize(sdkData: ITableDataModel, data: DeltaOf<ITableData>) {
        transaction(() => {
            const heights = data.graphic?.graphicData?.tbl?.tr
                ?.map((obj, index) => ({ index, height: obj?.h }))
                ?.filter(e => e.height !== undefined);
            const widths = data.graphic?.graphicData?.tbl?.tblGrid?.gridCol
                ?.map((obj, index) => ({ index, width: obj?.w }))
                ?.filter(e => e.width !== undefined);
            const transform = data.spPr?.xfrm;
            if (transform) {
                sdkData.api.updateTransform(transform);
            }
            if (heights) {
                sdkData.api.setTableRowHeights(heights as IHeightInfo[]);
            }
            if (widths) {
                sdkData.api.setTableColWidths(widths as IWidthInfo[]);
            }
        });
    }

    private getSelectionService(): ISelectionService | undefined {
        const appService = AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
        if (appService?.viewableServiceLayer?.selectionService) {
            return appService.viewableServiceLayer.selectionService;
        }
        return undefined;
    }

    /**
     * 从动画队列中移除绑定给形状 id 的动画
     * @param animListItem 动画队列
     * @param shapeId  形状 id
     * @returns 移除的数量
     */
    private removeAnimByShapeId = (animListItem: IAnimListItem, shapeId?: string): number => {
        if (!shapeId) return 0;

        let removeCount = 0;
        const anims = animListItem.data || [];
        const animCount = anims.length;

        if (!animCount) return 0;

        for (let i = animCount - 1; i >= 0; i--) {
            const anim = anims[i];
            if (anim.spid === shapeId) {
                removeCount += 1;
                /* NOTE：
                * 此处不使用 sdk 提供的 removeAnimationsByShapeId 方法，
                * 因为该方法会把触发器 (triggerId) 为 shapeId 的动画都移除
                */
                (this.sdkData as SlideModelSdkTypeV3)?.timing?.api
                    .removeAnimation(TimingPropertyConverter.getSdkTriggerId(animListItem.clickSpid), i);
            }
        }

        return removeCount;
    };

    // 获取存在颜色修改属性的动画类型的颜色值
    // 参看 src/framework/frame/components/animation-editor/anim-color-picker/index.tsx 中逻辑
    private getAnimationColorProperty(anim: IAnimModel): Record<string, any> | undefined {
        const colorPropertyAnimGroup = [
            AnimType.FillColor,
            AnimType.FontColor,
            AnimType.LineColor,
            AnimType.BrushColor,
            AnimType.ObjectColor,
            AnimType.ColorPulse,
            AnimType.GrowWithColor,
        ];

        if (!anim.props || !colorPropertyAnimGroup.includes(anim?.props.animType as AnimType)) return;
        const choiceList = (anim?.sdkData as any)?.par?.cTn.childTnLst.egTimeNodeChoice;
        const dataModel = anim.elementModel?.parent?.type === UIModelType.TABLE
            ? (anim.elementModel.parent.sdkData as BaseShapeDataModel)?.getPage?.()
            : anim.elementModel?.sdkData?.getPage?.();

        if (!choiceList || !dataModel) return;
        const color = getInitialColor(choiceList, dataModel);
        if (!color) return;
        // 修改sdk数据中的颜色
        const { colorValue, isSchemeColor } = color;
        const colorKey = isSchemeColor ? ColorKey.schemeClr : ColorKey.srgbClr;
        // 颜色string值不带# {srgbClr: '000000'}
        return { [colorKey]: colorValue };
    }
}

export default SlideBaseModel;
